import React, { useState } from 'react';
import logo from '../assets/niyukti logo.png';
import Primary_Button from './Primary_Button';
import '../Css/Navbar.css';
import { faAngleLeft, faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '@mui/material/Typography';
import ContactSupportForm from './ContactSupportForm';

function Navbar() {
    const [openSupport, setOpenSupport] = useState(false);

    const toggleNavbar = () => {
        const navbar = document.querySelector('.mobile_navbar');
        navbar.classList.toggle('mobile_navbar_active');
    };

    return (
        <>
            {/* Mobile Navbar */}
            <div className="mobile_navbar">
                <div className="navbar_close_btn" onClick={toggleNavbar}>
                    <FontAwesomeIcon icon={faAngleLeft} />
                </div>
                <div className="mobile_navbar_items">
                    <div className="mobile_navbar_logo_container">
                        <img src={logo} id='mobile_navbar_logo' alt="Niyukti Logo" />
                        <p>Niyukti</p>
                    </div>
                </div>
            </div>

            {/* Desktop Navbar */}
            <div className="navbar_container">
                <div className="navbar_items">
                    <div className="navbar_logo_container">
                        <div className="navbar_open_btn" onClick={toggleNavbar}>
                            <FontAwesomeIcon icon={faBars} style={{ fontSize: '20px', marginRight: '10px' }} />
                        </div>
                        <img src={logo} id='navbar_logo' alt="Niyukti Logo" />
                        <p>Niyukti</p>
                    </div>
                    <div className="navbar_support_section">
                        <div className="support_text">
                            <Typography variant="body1" className="support_heading">Need Help?</Typography>
                            <Typography variant="body2" className="support_subtext">Contact our support team</Typography>
                        </div>
                        <div className="navbar_loginbtn">
                            <Primary_Button
                                paddingProp="8px 30px 10px 30px"
                                textProp="Contact Us"
                                onClick={() => setOpenSupport(true)}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact Form Component */}
            <ContactSupportForm
                open={openSupport}
                handleClose={() => setOpenSupport(false)}
            />
        </>
    );
}

export default Navbar;
